import React, { useContext } from "react";
import Pagination from "../../Pagination";
import { CustomerContext } from "./CustomerContext";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";
// {hotels,formik,availableHotels,setRelToDel,postsPerPage,totalPosts,currentPage,paginate}
export default function CustomerHotels() {
  const styles = `
  .hotel-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.hotel-card {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  height: 400px; 
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.hotel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.edit-button, .delete-button {
  position: absolute;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1;
}

.edit-button {
  top: 10px;
  right: 10px;
  background-color: blue;
  color: white;
}

.delete-button {
  top: 10px;
  left:10px;
  background-color: red;
  color: white;
}

.data-overlay {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  width: calc(100% - 20px);
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .hotel-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 900px) {
  .hotel-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .hotel-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 400px) {
  .hotel-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

  let {formik, availableHotels, setRelToDel, newCustomerHotelsData, customerHotelsData, currentPage, postsPerPage, paginate } = useContext(CustomerContext)
   const foundHotelNames = availableHotels.length > 0 ? availableHotels.map(hotel => hotel.name) : null
  const shouldPaginate = customerHotelsData.length > 4 //customerHotelsData.length > 4
  const displayedHotels = shouldPaginate ? newCustomerHotelsData : customerHotelsData

  return (
    <div className="mt-2  mb-16 max-h-full min-h-fit">
      <div className="">
        <p>Want to communicate to different hotelOwners</p>
        <Link to="/customerDash/communicate/hotelOwners" className="hover:text-blue-500">hotelOwners</Link>
      </div>
      <h3 className="text-blue-500">Hotels</h3>
      {displayedHotels.length > 0 ?
        <div className="hotel-grid max-w-full min-w-fit">
          {displayedHotels.map((hotel, index) => (
            <div key={index} className="hotel-card">
              <div className="top-0 right-5">                  
                  <form onSubmit={formik.handleSubmit}>
                    <button className=" mt-2 delete-button " onClick={() => {
                      formik.setFieldValue("name", hotel.name);
                      setRelToDel(true)
                    }} type="submit">DELETE</button>
                  </form>
                </div>
              <div className="image-container">                
                <img src={hotel.image_url} alt={hotel.name} className="hotel-image " />
                <div className="data-overlay" key={hotel.id}>
                  <p className="text-white italic">{hotel.name}</p>
                  <p className=" text-white italic">{hotel.email}</p>
                  <p>{hotel.location}</p>
                </div>

              </div>
            </div>

          ))}
        </div>
        : <p>
          You do not have any hotels,want to add
        </p>
      }
      {shouldPaginate ? <Pagination postsPerPage={postsPerPage} totalPosts={customerHotelsData.length} currentPage={currentPage} paginate={paginate}  className=" flex flex-auto"/> : null}
      {availableHotels.length > 0 ?
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="name">Select a hotel</label>
          <select value={formik.name} name="name" id="name"
            onChange={formik.handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            <option>Select a hotel</option>
            {foundHotelNames.map((hotel, index) =>
            (
              <option value={hotel} key={index}>
                {hotel}
              </option>
            ))}
          </select>
          <button className="bg-blue-500 rounded-lg text-white disabled:opacity-50" type="submit" onClick={(e) => {
            setRelToDel(false);
          }} disabled={formik.isSubmitting || !formik.isValid}>Send Request</button>
        </form>
        : null}

    </div>
  )
}
